import request from "@/utils/hotelRequest";

// 获取嘉银已开通页面信息
export const getJiayinDetail = params => {
  return request({
    url: "/api/core/jiayin/benefits_info",
    method: "get",
    params
  });
};

// 获取嘉银分期账单
export const getJiayinBill = data => {
  return request({
    url: "/api/core/jiayin/bill_order",
    method: "POST",
    data
  });
};

// 获取嘉银分期账单
export const getJiayinPaymentInfo = data => {
  return request({
    url: "/api/core/jiayin/query_pay_info",
    method: "POST",
    data
  });
};

// 获取嘉银分期账单
export const jiayinPaymentPay = data => {
  return request({
    url: "/api/core/jiayin/payment_pay",
    method: "POST",
    data
  });
};

// 获取嘉银支付结果
export const jiayinPaymentResult = data => {
  return request({
    url: "/api/core/jiayin/query_pay_result",
    method: "POST",
    data
  });
};

// 查询嘉银是否可以取消续费操作
export const jiayinQueryMonthlySubscription = data => {
  return request({
    url: "/api/core/jiayin/user_query_continuous",
    method: "POST",
    data
  });
}

// 取消连续包月
export const cancelMonthlySubscription = data => {
  return request({
    url: "/api/core/jiayin/user_cancel_continuous",
    method: "POST",
    data
  });
}

// 取消扣费
export const cancelDeduction = data => {
  return request({
    url: "/api/core/jiayin/user_cancel_benefit",
    method: "POST",
    data
  });
}

// 嘉银退款
export const fetchRefund = data => {
  return request({
    url: "/api/core/jiayin/user_apply_refund",
    method: "POST",
    data
  })
}

// 获取嘉银金融权益跳转链接
export const getJiayinJumpLink = data => {
  return request({
    url: "/api/core/jiayin/get_coupon_url",
    method: "POST",
    data
  })
}

// 获取挽留包行权弹窗
export const getJYRetainModal = data => {
  return request({
    url: "/api/core/jiayin/retention_package_exercise",
    method: "POST",
    data
  })
}

// 嘉银加赠挽留模块楼层
export const getJYRetainModalFloor = data => {
  return request({
    url: "/api/core/jiayin/retention_exercise_module",
    method: "POST",
    data
  })
}

// 保险领取联登
export const getInsuranceLogin = data => {
  return request({
    url: "/api/core/jiayin/retention_standard_benefit",
    method: "POST",
    data
  })
}

// 嘉银挽留H5页面
export const getJiayinRetainH5 = data => {
  return request({
    url: "/api/core/jiayin/retention_retention_h5_page",
    method: "POST",
    data
  })
}

// 嘉银H5挽留弹窗
export const getJiayinH5RetainModal = data => {
  return request({
    url: "/api/core/jiayin/retention_package_popup",
    method: "POST",
    data
  })
}

// 嘉银H5挽留弹窗去使用
export const jiayinH5RetainModalUse = data => {
  return request({
    url: "/api/core/jiayin/retention_open_retention_package",
    method: "POST",
    data
  })
}
